var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-currency-field',_vm._b({ref:"input",attrs:{"value":_vm.getVal},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-currency-field',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }